import assetPath from '/app/xinglets/upsell/campaign-page/src/assets/gdpr.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')